import React from "react";
import Reveal from "@/components/Reveal";
import { PROJECTS } from "@/data/site";
import { serif, mont, COLORS, es } from "./ui";

const V2Proyectos = () => {
  return (
    <div data-testid="v2-proyectos">
      <section className="max-w-6xl mx-auto px-6 pt-10 pb-12">
        <p className="text-xs uppercase tracking-[0.3em] mb-5" style={{ ...mont, color: COLORS.green, fontWeight: 600 }}>Portfolio</p>
        <h1 className="text-5xl sm:text-6xl font-light leading-[1]" style={serif}>Proyectos</h1>
        <p className="mt-7 text-lg leading-relaxed max-w-2xl" style={{ color: COLORS.sec }}>
          Una selección de trabajos entre marketing y producción audiovisual para marcas e instituciones.
        </p>
      </section>

      <section className="max-w-6xl mx-auto px-6 pb-24 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12" style={{ borderTop: `1px solid ${COLORS.border}`, paddingTop: "3rem" }}>
        {PROJECTS.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 3) * 0.07}>
            <div className="group">
              <div className="overflow-hidden aspect-[4/3] mb-4" style={{ border: `1px solid ${COLORS.border}` }}>
                <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <p className="text-[10px] uppercase tracking-[0.22em]" style={{ ...mont, color: p.branch === "audiovisual" ? COLORS.gold : COLORS.green, fontWeight: 600 }}>{es(p.kicker)}</p>
              <h3 className="mt-1.5 text-2xl font-normal" style={serif}>{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed" style={{ color: COLORS.sec }}>{es(p.summary)}</p>
            </div>
          </Reveal>
        ))}
      </section>
    </div>
  );
};

export default V2Proyectos;
